module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-mobile-94da480ce76da7c5c64a65451daa27e4.webp";